module.exports = __webpack_public_path__ + "img/LumoraLogoHorizontal.40a98bb7.png";